module.exports = require('./html5_video');




/** WEBPACK FOOTER **
 ** ./src/playbacks/html5_video/index.js
 **/